import { render, staticRenderFns } from "./MppAppMenu.vue?vue&type=template&id=d8a2d394&scoped=true&"
import script from "./MppAppMenu.vue?vue&type=script&lang=js&"
export * from "./MppAppMenu.vue?vue&type=script&lang=js&"
import style0 from "./MppAppMenu.vue?vue&type=style&index=0&id=d8a2d394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a2d394",
  null
  
)

export default component.exports